import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {DictionaryService} from '../../../services/dictionary.service';
import {Store} from '@ngxs/store';
import {DictionaryActions} from '../../../state/dictionary/dictionary.actions';
import {map} from 'rxjs/operators';

@Injectable()
export class DictionaryResolver implements Resolve<any> {
    constructor(
        private dictionaryService: DictionaryService,
        private store: Store,
    ) {
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        return this.store.dispatch(new DictionaryActions.Download(route.data.dictionaries || []))
            .pipe(map(() => null));
    }
}
